// Build-page photo viewer. Clicking the hero or any thumbnail opens a full-size
// slideshow (RJ, 2026-09-14 — before this, the thumbnails were decoration: they
// were bare <img> with no handler, so nothing on the page enlarged a photo).
//
// Native <dialog>: Escape, the top layer and focus trapping come free, and it
// cannot end up underneath the sticky header the way a hand-rolled overlay can.
//
// The full-size URLs come from the JSON beside the gallery, not from the <img> on
// the page — those are served at 480 (thumbs) and 1600 (hero), neither of which is
// what a viewer should show.
(function () {
  var gallery = document.querySelector("[data-pl-gallery]");
  var dialog = document.querySelector("[data-pl-lightbox]");
  if (!gallery || !dialog || typeof dialog.showModal !== "function") return;

  var stage = dialog.querySelector("[data-pl-stage]");
  if (!stage) return;
  // Built here rather than in Liquid: the dimensions are unknown until a photo is
  // chosen, and a static <img> without width/height fails theme check.
  var img = document.createElement("img");
  img.className = "pl-lightbox__img";
  img.alt = stage.dataset.plAlt || "";
  stage.appendChild(img);
  var countEl = dialog.querySelector("[data-pl-count]");
  var prevBtn = dialog.querySelector("[data-pl-prev]");
  var nextBtn = dialog.querySelector("[data-pl-next]");

  var shots = [];
  try {
    shots = JSON.parse(gallery.querySelector("[data-pl-shots]").textContent) || [];
  } catch (e) {
    return; // No usable URLs: leave the page exactly as it was, with no dead buttons.
  }
  if (!shots.length) return;

  var index = 0;
  var opener = null; // focus goes back where it came from on close

  function show(i) {
    index = (i + shots.length) % shots.length; // wraps both ways
    img.src = shots[index];
    if (countEl) countEl.textContent = index + 1 + " / " + shots.length;
    // One photo is not a slideshow.
    var solo = shots.length < 2;
    if (prevBtn) prevBtn.hidden = solo;
    if (nextBtn) nextBtn.hidden = solo;
  }

  function open(i, from) {
    opener = from || null;
    show(i);
    dialog.showModal();
  }

  gallery.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-pl-shot]");
    if (!btn) return;
    open(Number(btn.dataset.plShot) || 0, btn);
  });

  if (prevBtn) prevBtn.addEventListener("click", function () { show(index - 1); });
  if (nextBtn) nextBtn.addEventListener("click", function () { show(index + 1); });
  dialog.querySelectorAll("[data-pl-close]").forEach(function (b) {
    b.addEventListener("click", function () { dialog.close(); });
  });

  dialog.addEventListener("keydown", function (e) {
    if (e.key === "ArrowRight") { e.preventDefault(); show(index + 1); }
    else if (e.key === "ArrowLeft") { e.preventDefault(); show(index - 1); }
  });

  // Backdrop click closes. The dialog element fills the viewport, so "outside" is
  // measured against the image and controls, not against the element itself.
  dialog.addEventListener("click", function (e) {
    if (e.target.closest(".pl-lightbox__img, [data-pl-prev], [data-pl-next], [data-pl-close]")) return;
    dialog.close();
  });

  dialog.addEventListener("close", function () {
    img.removeAttribute("src"); // stop a large image sitting in memory while closed
    if (opener && typeof opener.focus === "function") opener.focus();
    opener = null;
  });
})();
